import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NavBar from './NavBar';
import HomeView from './views/HomeView';
import ProductView from './views/ProductView';
import InstallationView from './views/InstallationView';
import ManualView from './views/ManualView';
import AboutUsView from './views/AboutUsView';
import ContactUsView from './views/ContactUsView';
import { LanguageProvider } from './LanguageContext';

import { Box } from '@mui/material';
function App() {
  return (
    <LanguageProvider>
      <Router>
        <Box className="App" sx={{ maxWidth: { sm: '100%', lg: '66%' }, mx: 'auto' }}> {/* Ensure Box is centered and responsive */}
          <NavBar />
          <Routes>
            <Route path="/" element={<HomeView />} />
            <Route path="/product" element={<ProductView />} />
            <Route path="/installation" element={<InstallationView />} />
            <Route path="/usermanual" element={<ManualView />} />
            <Route path="/aboutus" element={<AboutUsView />} />
            <Route path="/contact" element={<ContactUsView />} />
          </Routes>
        </Box>
      </Router>
    </LanguageProvider>
  );
}
export default App;
